import { render, staticRenderFns } from "./FriendsList.vue?vue&type=template&id=be2ac8bc&"
import script from "./FriendsList.vue?vue&type=script&lang=js&"
export * from "./FriendsList.vue?vue&type=script&lang=js&"
import style0 from "./FriendsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports